module["exports"] = [
  "Pan",
  "Pani"
];
